import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

export default function getLocalUrlOverride(): string | undefined {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return (globalThis as GlobalThisWithLocalDevContext).localDevContext?.LOCAL_URL_OVERRIDE;
}
